export default __webpack_public_path__ + "static/media/email-icon.9082177d.png";